import React from 'react'
import Spinner from "react-bootstrap/Spinner";

const PlaceholderLoader = () => {
    return (
        <div>
            <Spinner animation="border" />
        </div>
    )
}

export default PlaceholderLoader